import { Stack, Text, Tooltip } from '@mantine/core';
import dayjs from 'dayjs';
import { i18nKeys, useTranslation } from 'locales';

import { useCompanyNameOf, useConsolidation } from './consolidation';

type GroupComputedAtProps = { selectedCompanies: ReadonlyArray<string> };

export const GroupComputedAt = ({ selectedCompanies }: GroupComputedAtProps) => {
  const { t } = useTranslation();
  const companyNameOf = useCompanyNameOf();
  const { groupAnalytics } = useConsolidation(selectedCompanies);

  if (!groupAnalytics?.computedAt) return null;

  const { computedAt, contributions } = groupAnalytics;

  return (
    <Tooltip
      disabled={contributions.length === 0}
      label={
        <Stack gap={2}>
          {contributions.map(({ company, computedAt: contributedAt }) => (
            <Text key={company} size="xs">
              {`${companyNameOf(company)} — ${dayjs(contributedAt).format('LLL')}`}
            </Text>
          ))}
        </Stack>
      }
    >
      <Text span c="gray.6" size="xs" data-tour="group-computed-at">
        {t(i18nKeys.GROUP.OLDEST_COMPUTED_AT, { date: dayjs(computedAt).format('LL') })}
      </Text>
    </Tooltip>
  );
};
